import ClientLayout from "../../../components/client/layout/ClientLayout";
import ClientBilling from "../../../components/client/billing/ClientBilling";

//클라이언트 결제 페이지
const ClientBillingPage: React.FC = () => {
    return (
        <ClientLayout>
            {/*클라이언트 결제 정보*/}
            <ClientBilling/>
        </ClientLayout>
    )
}
export default ClientBillingPage;